import React from 'react';

export default function PerPageSelect({ value, options = [10, 25, 50, 100], label, onChange }) {
    return (
        <div className="tw-flex tw-items-center tw-space-x-1.5">
            <label className="table__select-page-len__label">{label ?? $t('Show')}</label>
            <select className="table__select-page-len" value={String(value)} onChange={onChange}>
                {options.map((option) => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </select>
        </div>
    );
}
